import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import map from 'lodash/map';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { isMobileAny } from '../../utils/device';

import { Notification } from './Notification';

import classes from './styles/index.module.scss';

class NotificationsContainer extends Component {
	render() {
		const { className, notifications } = this.props;

		const containerClassNames = classNames(
			classes.container,
			{
				[classes.container_mobile]: isMobileAny,
			},
			className,
		);

		const notificationsCSSTransitionClassNames = {
			appear: 'fade',
			appearActive: '',
			enter: classes.fadeEnter,
			enterActive: classes.fadeEnterActive,
			enterDone: '',
			exit: classes.fadeExit,
			exitActive: classes.fadeExitActive,
			exitDone: '',
		};
		return (
			notifications.length > 0 && (
				<div className={containerClassNames}>
					<TransitionGroup className={classes.containerInner}>
						{map(notifications, (notification) => (
							<CSSTransition
								key={notification.id}
								timeout={600}
								classNames={notificationsCSSTransitionClassNames}
							>
								<Notification
									{...this.props}
									{...notification}
									key={notification.id}
								/>
							</CSSTransition>
						))}
					</TransitionGroup>
				</div>
			)
		);
	}
}

NotificationsContainer.propTypes = {
	className: PropTypes.string,
	notifications: PropTypes.array,
};

NotificationsContainer.defaultProps = {
	className: '',
	notifications: [],
};

export { NotificationsContainer };
